module.exports = __webpack_public_path__ + "media/store/fonts/BatonNouveauVar-ececbe70f044fcc37594106200648415.woff2";